import {
  MinusCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';
import React from 'react';

import { MarketplaceItemStatus } from '../types/types';

interface MarketplaceStatusTagProps {
  status: MarketplaceItemStatus;
}

const statusMap: Record<
  MarketplaceItemStatus,
  { icon?: React.ReactNode; color: string; label: string }
> = {
  [MarketplaceItemStatus.Active]: {
    color: 'success',
    label: 'Ativa',
  },
  [MarketplaceItemStatus.Draft]: {
    icon: <SyncOutlined />,
    color: 'processing',
    label: 'Rascunho',
  },
  [MarketplaceItemStatus.Unpublished]: {
    icon: <MinusCircleOutlined />,
    color: 'default',
    label: 'Despublicado',
  },
  [MarketplaceItemStatus.Scheduled]: {
    color: 'warning',
    label: 'Agendada',
  },
};

export const MarketplaceStatusTag: React.FC<MarketplaceStatusTagProps> = ({
  status,
}) => {
  const { icon, color, label } = statusMap[status] || {
    icon: null,
    color: 'default',
    label: status,
  };

  return (
    <Tag icon={icon} color={color}>
      {label}
    </Tag>
  );
};
